require([
	'jquery',
	'base/MbiHelper',
	'project/MbiConfig',
	'base/MbiMediaQuery',
	'base/MbiImageSize'	
	
], function($,
	_,
	mbiConfig,
	mbiMq, 
	mbiImageSize	
	
) {
	'use strict';


	// moved to Locations.js

	// $('.js-posts-nav').on('click', function () {
	// 	$('.hidden-job').slideDown('fast');
	// 	$(this).slideUp('fast');
	// });


});
define("root/Assets/Templates/Html/JobOffers/Js/JobOffers", function(){});

